import auctionApiClient, { auctionV2ApiClient } from '../auctions-list-page/AuctionApiClient';
import { SourceAuctionIdStorageKey, AuctionListPageReturnUrlStorageKey } from '../auctions-list-page/contracts';
import events from '../events';
import { formatDateTime } from '../utils/formatDate';
import formatPrice from '../utils/formatPrice';
import logger from "../utils/logger";
export function auctionObjectPage(data) {
    return {
        activeTab: "description",
        itemHistoryBids: [],
        formatPrice,
        formatDate: formatDateTime,
        init() {
            logger.pageView();
            events.onAuctionItemBid.subscribe(() => {
                this.fetchHistoryBids();
            });
        },
        fetchHistoryBids() {
            auctionV2ApiClient.getItemHistory(data.id)
                .then(entries => {
                this.itemHistoryBids = entries;
            });
        },
        changeTab(tab) {
            this.activeTab = tab;
            if (tab == "history" && this.itemHistoryBids.length == 0) {
                this.fetchHistoryBids();
            }
        },
    };
}
export function auctionObjectPageControl(data) {
    return {
        showControls: false,
        prevItemUrl: "",
        nextItemUrl: "",
        init() {
            var _a;
            const sourceAuctionId = (_a = localStorage.getItem(SourceAuctionIdStorageKey)) !== null && _a !== void 0 ? _a : "";
            const isMobile = /android|iphone/.test(navigator.userAgent.toLowerCase());
            const breadcrumbsEl = document.getElementById("breadcrumbs");
            this.showControls = sourceAuctionId === data.auctionId.toString();
            if (!this.showControls || breadcrumbsEl == null)
                return;
            const searchQuery = {
                auctionId: data.auctionId,
                minLotNumber: data.number - 1,
                maxLotNumber: data.number + 1,
                type: "AllItems",
                sortOrder: "ObjectNumber",
            };
            auctionApiClient.searchItems(searchQuery).then(result => {
                const prevItem = result.items.find(x => x.number == data.number - 1);
                const nextItem = result.items.find(x => x.number == data.number + 1);
                this.prevItemUrl = (prevItem === null || prevItem === void 0 ? void 0 : prevItem.relativeUrl) ? `${data.auctionUrl}/${prevItem.relativeUrl}` : "";
                this.nextItemUrl = (nextItem === null || nextItem === void 0 ? void 0 : nextItem.relativeUrl) ? `${data.auctionUrl}/${nextItem.relativeUrl}` : "";
                const lastBreadcrumb = breadcrumbsEl.children[breadcrumbsEl.children.length - 1];
                const returnUrl = localStorage.getItem(AuctionListPageReturnUrlStorageKey);
                if (lastBreadcrumb && returnUrl) {
                    const a = document.createElement('a');
                    a.setAttribute('href', returnUrl);
                    a.innerHTML = data.backToList;
                    lastBreadcrumb.replaceChildren(a);
                }
                if (isMobile) {
                    const rect = breadcrumbsEl.getBoundingClientRect();
                    window.scrollTo(0, rect.y);
                }
            });
        }
    };
}
